import { gql } from "graphql-tag";

export const QUERY = gql`
  query RelatedInterestActions($interestListID: ID!, $interestID: ID!) {
    interest(id: $interestID) {
      id
      status {
        name
        changedAt
      }
      interestListId
      userId
    }

    interestList(id: $interestListID) {
      id
      waitListId
    }

    activityFeed(resourceId: $interestID) {
      id
      name
      insertedAt
      title
      type
      note
      authorFullName
      message {
        status
        error {
          code
          message
        }
        recipientName
        body
        mobileNumber
      }
      metadata {
        to
        emailSubject
        emailBody
        viewerName
        errorsMap
        updateDiff
        reason
        activityContent
      }
      letterJob {
        lobLetterId
        status
        errorMessage
      }
    }
  }
`;

export const CHANGE_STATUS = gql`
  mutation ChangeInterestStatus($interestId: ID!, $status: String!, $reason: String) {
    changeInterestStatus(interestId: $interestId, status: $status, reason: $reason)
  }
`;

export const SKIP_INTEREST = gql`
  mutation skipInterestAction($data: SkipInterestInput!) {
    skipInterest(data: $data) {
      id
      note
    }
  }
`;

export const SKIP_INTERESTS = gql`
  mutation skipInterestsAction($interestIds: [ID!], 
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int,
    $reason: String!) {
    skipInterests(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom,
      note: $reason
    )
  }
`;

export const ADD_NOTE_TO_INTERESTS = gql`
  mutation addNoteToInterests(
    $interestIds: [ID!],
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int,
    $note: String!
  ) {
    addNoteToInterests(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom,
      note: $note
    )
  }
`;

// Bulk owner assign: ADDS every listed owner to each interest in the bulk scope,
// keeping existing owners. Mirrors the bulk-scope variable shape used by
// ADD_NOTE_TO_INTERESTS so the same getScope()/page-range props flow in.
export const ASSIGN_INTEREST_OWNERS_BULK = gql`
  mutation assignInterestOwnersBulk(
    $interestIds: [ID!],
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int,
    $userIds: [String!]!
  ) {
    assignInterestOwnersBulk(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom,
      userIds: $userIds
    ) {
      succeeded
      failed {
        interestId
        name
        reason
      }
    }
  }
`;

// Bulk owner remove: drops only the listed owners. `$userIds` is declared
// non-null on purpose — the server treats an OMITTED userIds as the deprecated
// remove-every-owner, and an unset nullable variable counts as omitted, so a
// required variable makes "forgot to pass userIds" a validation error instead.
export const REMOVE_INTEREST_OWNERS_BULK = gql`
  mutation removeInterestOwnersBulk(
    $interestIds: [ID!],
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int,
    $userIds: [String!]!
  ) {
    removeInterestOwnersBulk(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom,
      userIds: $userIds
    ) {
      succeeded
      failed {
        interestId
        name
        reason
      }
    }
  }
`;

// The distinct owners of a bulk selection (server-ordered by display name), scoped
// exactly like REMOVE_INTEREST_OWNERS_BULK so the Remove picker only offers owners
// the removal can actually reach — including rows beyond the visible page.
export const BULK_SELECTION_OWNERS = gql`
  query bulkSelectionOwners(
    $interestIds: [ID!],
    $interestListIds: [ID!]!,
    $elasticQuery: ElasticQuery,
    $pageFrom: Int,
    $pageTo: Int
  ) {
    bulkSelectionOwners(
      interestListIds: $interestListIds,
      interestIds: $interestIds,
      elasticQuery: $elasticQuery,
      pageTo: $pageTo,
      pageFrom: $pageFrom
    ) {
      id
      profile {
        firstName
        lastName
      }
    }
  }
`;

export const TAG_ELIGIBILITY = gql`
  mutation tagEligible($interestId: ID!, $isEligible: Boolean!) {
    tagInterestAsEligible(interestId: $interestId, isEligible: $isEligible) {
      id
    }
  }
`;

export const SEND_FULL_APP = gql`
mutation sendForm($interestId: ID!, $type: FormType!, $deadline: String!) {
  sendFormToInterest(type: $type, interestId: $interestId, deadline: $deadline) {
    id
  }
}
`;

export const SEND_FULL_APP_TO_INTERESTS = gql`
mutation sendFormToInterests($interestIds: [ID!]!, $type: FormType!, $deadline: String!) {
  sendFormToInterests(type: $type, interestIds: $interestIds, deadline: $deadline) {
    type
  }
}
`;

export const SYNC_ONE_SITE_GUEST_CARD = gql`
mutation syncOneSiteGuestCard($interestId: ID!) {
  onesiteSyncGuestCard(interestId: $interestId){
    interestId
  }
}
`;
